// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-entities-editor__divider{margin-bottom:20px}", "",{"version":3,"sources":["webpack://./src/js/components/audience-insights/SelectedTopicsEditor.scss"],"names":[],"mappings":"AACE,mCACE,kBAAA","sourcesContent":[".selected-entities-editor {\n  &__divider {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
